
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/forApi/[eid]",
      function () {
        return require("private-next-pages/forApi/[eid].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/forApi/[eid]"])
      });
    }
  